/* Owner's guide pages: on desktop the "On this page" strip sticks under the
   header and lights the section you're reading. Pure enhancement — with no
   JS the strip is a plain list of anchors, and on phones it never sticks.
   Loaded by every sections/glide-guide-*.liquid alongside glide-guide.css. */
(function () {
  var toc = document.querySelector('.acgd-toc');
  if (!toc) return;
  var wrap = toc.closest('.acgd-tocwrap') || toc;
  var mq = window.matchMedia('(min-width: 990px)');
  var root = document.documentElement;
  var header = document.querySelector('.section-header');
  var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
  var targets = links.map(function (a) {
    return document.getElementById(a.getAttribute('href').slice(1));
  });
  var current = null;
  var ticking = false;

  // Where the strip should stick: right under the header while the header is
  // showing, at the very top once the header has slid away.
  function updateTop() {
    var top = 0;
    if (header && header.classList.contains('shopify-section-header-sticky') &&
        !header.classList.contains('shopify-section-header-hidden')) {
      top = header.offsetHeight;
    }
    root.style.setProperty('--acgd-top', top + 'px');
  }

  // Which section is under the strip right now.
  function spy() {
    ticking = false;
    if (!mq.matches) { if (current) { current.classList.remove('is-current'); current = null; } return; }
    var line = wrap.getBoundingClientRect().bottom + 12;
    var hit = null;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t && t.getBoundingClientRect().top <= line) hit = links[i];
    }
    if (hit !== current) {
      if (current) current.classList.remove('is-current');
      if (hit) hit.classList.add('is-current');
      current = hit;
    }
    wrap.classList.toggle('is-stuck', wrap.getBoundingClientRect().top <= (parseFloat(root.style.getPropertyValue('--acgd-top')) || 0) + 0.5 && window.scrollY > 40);
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(spy); } }

  updateTop();
  spy();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { updateTop(); onScroll(); });
  if (mq.addEventListener) mq.addEventListener('change', function () { updateTop(); onScroll(); });
  if (header && window.MutationObserver) {
    new MutationObserver(function () { updateTop(); onScroll(); })
      .observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  // Offset anchor jumps so the heading lands below the strip, not under it.
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t || !mq.matches) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - wrap.offsetHeight - (parseFloat(root.style.getPropertyValue('--acgd-top')) || 0) - 24;
      window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  });
})();
